module.exports = __webpack_public_path__ + "static/Challenges0-c2b990be1ef25ab2d4ce1d5a6dcb6379.png";